module.exports = __webpack_public_path__ + "img/imagenCincoConstruccion.b180db28.png";